{
  "id": 4,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 12,
  "kinds": 5,
  "goals": [
    { "type": "collect", "kind": "croissant", "count": 36 }
  ],
  "stars": [4750, 6320],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.955, "movesLeft": 4.2, "closeLosses": 0.014, "target": 0.92 }
}
